var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGithubDark = function SvgGithubDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "github-dark_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.25A8.748 8.748 0 0 0 1.25 10c0 3.867 2.508 7.144 5.984 8.304.435.08.596-.188.596-.424 0-.21-.005-.758-.01-1.488-2.434.526-2.95-1.171-2.95-1.171-.397-1.01-.972-1.284-.972-1.284-.795-.542.06-.531.06-.531.875.064 1.342.902 1.342.902.779 1.337 2.047.95 2.546.725.08-.564.306-.95.553-1.171-1.939-.215-3.98-.967-3.98-4.319 0-.956.339-1.735.903-2.347-.092-.225-.393-1.112.08-2.315 0 0 .736-.236 2.406.897A8.491 8.491 0 0 1 10 5.483a8.523 8.523 0 0 1 2.191.295c1.671-1.133 2.407-.897 2.407-.897.478 1.203.177 2.095.086 2.315.559.612.897 1.391.897 2.347 0 3.363-2.047 4.099-3.996 4.319.311.269.596.806.596 1.622 0 1.171-.011 2.111-.011 2.401 0 .236.156.505.602.42a8.75 8.75 0 0 0 5.978-8.3A8.749 8.749 0 0 0 10 1.25Z",
    fill: "currentColor"
  })));
};

export default SvgGithubDark;